document.addEventListener('DOMContentLoaded', () => {

  const items = document.querySelectorAll('[data-scroll-item]');
  const images = document.querySelectorAll('[data-image]');

  if (!items.length) return;

  const observer = new IntersectionObserver((entries) => {

    entries.forEach((entry) => {

      if (!entry.isIntersecting) return;

      const id = entry.target.dataset.scrollItem;

      images.forEach((img) => {
        img.classList.remove('is-active');
      });

      const activeImage = document.querySelector(`[data-image="${id}"]`);

      if (activeImage) {
        activeImage.classList.add('is-active');
      }

    });

  }, {
    threshold: 0.45
  });

  items.forEach((item) => {
    observer.observe(item);
  });

});